import { render, staticRenderFns } from "./NewRowTwoAuto.vue?vue&type=template&id=66d7c868&"
import script from "./NewRowTwoAuto.vue?vue&type=script&lang=js&"
export * from "./NewRowTwoAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d7c868')) {
      api.createRecord('66d7c868', component.options)
    } else {
      api.reload('66d7c868', component.options)
    }
    module.hot.accept("./NewRowTwoAuto.vue?vue&type=template&id=66d7c868&", function () {
      api.rerender('66d7c868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/homepage/NewRowTwoAuto.vue"
export default component.exports